import type { TopicResource } from '../../types/api'

/** Resource kinds that integrate with the outside world — the
 * "connections" facet of the redesigned resources views. Everything else
 * is a document-like artifact created by an agent or a human. */
const CONNECTION_KINDS = new Set([
  'git_repo',
  'github',
  'mcp',
  'webhook',
  'cron',
  'web',
  'sqlite_db',
])

export function isConnectionKind(kind: string): boolean {
  return CONNECTION_KINDS.has(kind)
}

/** Review-state-bearing kinds whose `data.status` gates the
 * "needs review" facet (see the Phase-0 derivation for the same JSON
 * predicate server-side). Returns the flag-chip label, or null when the
 * row needs no review affordance. */
export function reviewFlag(r: TopicResource): 'approve' | 'answer' | null {
  const data = r.data as Record<string, unknown> | undefined
  if (data?.status !== 'submitted') return null
  if (r.kind === 'plan') return 'approve'
  if (r.kind === 'question') return 'answer'
  return null
}
